<template>
  <div>
    <div class="text-center mt-0 mb-3" v-if="Caricatoqui == false">
        <b-spinner
            variant="primary"
            style="width: 2.5rem; height: 2.5rem;"
            class="mr-1"
            label="loading"
        />
    </div>

    <div v-else>
      <div v-if="this.testata_nome_pacchetto">
        <h3 class="mb-1">{{ this.testata_nome_pacchetto }}</h3>
        <h6 class="mb-3">
          <span v-if="this.field_split_payment == 'No'">
            <span v-if="this.field_vat_scheme_id == 1">
            Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 1) }}
            </span>
            <span v-else>
              Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 0) }}
            </span> 
          </span>
          <span v-else>
            Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 0) }}
          </span>
        </h6>
      </div>
          
    </div>

    <div v-if="!this.isSuccess">
        <form @submit.prevent="handleSubmit">
        <!-- Elemento Stripe Payment Element -->
        <div id="payment-element"></div>

        <!-- Errori di pagamento -->
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>

        <div v-if="isButtonVisible" class="mt-2">
            <b-button 
            variant="outline-primary" 
            class="text-uppercase mb-3" 
            type="submit" 
            :disabled="isLoading || !isFormValid"
            >
            
            <div v-if="isLoading">Aggiornamento in corso <b-spinner small class="ml-1" /></div>
            <div v-else>Aggiorna metodo di pagamento</div> 
            </b-button>
        </div>


        </form>
    </div>
    <div v-else>
        <h3 class="mb-1">Metodo di pagamento aggiornato con successo!</h3>
        <p>Le ricordiamo che per la conferma del pagamento andato a buon fine della sua licenza potrebbero essere necessari fino a 3 giorni lavorativi.</p>
        <p>
            <b-button 
            variant="outline-primary" 
            class="text-uppercase mb-5"
            @click="$router.push({ name: 'area-clienti-licenze' })"
            >Torna alle Licenze</b-button>
        </p>
    </div>

  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { BButton, BSpinner } from 'bootstrap-vue'


export default {
  components: {
    BButton, 
    BSpinner, 
  },
  props: {
    field_stripe_api_key: {
      type: String,
      required: true,
    },
    field_payment_intent: {
      type: String,
      required: true,
    },
    field_license_id: {
      type: Number,
      //type: String,
      required: true,
    },
    field_customer: {
      type: String,
      required: true,
    },
    field_codice_contratto: {
      type: String,
      required: true,
    },
    field_product_id: {
      type: String,
      required: true,
    },
    field_is_subscription: {
      type: Boolean,
      required: true,
    },
    field_vat_scheme_id: {
      type: Number,
      required: true,
    },
    field_split_payment: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      Caricatoqui: false, 

      stripe: null,
      elements: null,
      paymentElement: null,
      isLoading: false,
      errorMessage: null,
      isSuccess: false,

      testata_nome_pacchetto: '',
      testata_prezzo_pacchetto: '',
      testata_iva_pacchetto: null,
      
      nome_pacchetto: '',
      price_pacchetto_stripe: '', // 'price_XXXX' - serve solo per le subscription

      isButtonVisible: false,  // Inizialmente il bottone non è visibile
      isFormValid: false, // Stato di validità del form

      selectedPaymentMethod: null,

      importo_da_tassare_su_stripe: 0, //default 0 = No, non da tassare

      clientSecretOk: '',
    };
  },
  computed: {
    formattedAmount() {
      return (this.amount / 100).toFixed(2) + ' €';
    },
  },
  async mounted() {
    console.log("Siamo in CHANGEPAYMENT_v2.VUE - async mounted ---------------------------------")
    console.log(this.field_payment_intent)
    console.log("field_license_id -> "+this.field_license_id)

    //caricare informazioni di default per il nome del pacchetto che andremo a pagare a prescindere dalle operazioni successive
    this.$http.get('api/customer/stripe/infolicenza/'+this.field_product_id).then(response_pacchetto => { 
      //console.log(response_pacchetto)
      //alert("NOME PACCHETTO -> "+response_pacchetto.data.reply.name)

      this.testata_nome_pacchetto = response_pacchetto.data.reply.name;
      this.testata_prezzo_pacchetto = response_pacchetto.data.reply.default_price.unit_amount;
      this.testata_iva_pacchetto = response_pacchetto.data.reply.tax_code; //se NON indicato su Stripe nella scheda del prodott è di defualt NULL

      this.Caricatoqui = true;
      
    }).catch(e => {
      console.log("Errore api recupero stripe infolicenza ......")
      console.log(e)

      this.Caricatoqui = false;
      alert("Errore nel caricamento delle informazioni del pacchetto ...")
    });

    /////////////////////////
    // Inizio procedura di cambio metodo di pagamento - Speriamo bene ...

    //gestione pagamento con IVA o senza IVA (esente)
    if(this.field_split_payment == 'No'){
        if(this.field_vat_scheme_id == 1){
            //iva al 22% => applica iva all'importo su Stripe
            this.importo_da_tassare_su_stripe = 1
        } else {
            //iva esente => NON applicare iva all'importo su Stripe
            this.importo_da_tassare_su_stripe = 0
        }
    } else{
        //se Spilt payment = si => su Stripe NO iva
        this.importo_da_tassare_su_stripe = 0
    }


    if(this.field_is_subscription === true){
        //Abbonamento
        console.log("Siamo in ABBONAMENTO ---------------")

        const response = this.$http.post('/api/customer/stripe/crea-setup-intent-per-abbonamento-fallito', 
            {
            currency: 'eur', // Specifica la valuta
            payment_method_types: ['card', 'sepa_debit'], // Metodi di pagamento supportati 
            customer: this.field_customer, 
            license_id: this.field_license_id, 
            description: 'Contratto n. '+this.field_codice_contratto,
            product_id: this.field_product_id,
            }
        );

        const risposta = await response

        console.log("risposta .............")
        console.log(risposta)
        console.log("dati dall'api .............")
        console.log(risposta.data.reply)

        const { clientSecret } = risposta.data.reply;

        if (!clientSecret) {
            throw new Error('Il clientSecret non è stato restituito dal server.');
        }

        //visualizza dati
        this.nome_pacchetto = risposta.data.reply.nome_pacchetto

        // 'price_XXXX' di Stripe del pacchetto (serve in caso di subscription)
        this.price_pacchetto_stripe = risposta.data.reply.prezzo_pacchetto

        this.stripe = await loadStripe(this.field_stripe_api_key); // Inserisci qui la tua chiave pubblica
        this.elements = this.stripe.elements({ clientSecret });

        //salvo per i successivi passaggi (pagamento)
        this.clientSecretOk = risposta.data.reply.clientSecret 

        // Configura il Payment Element
        this.paymentElement = this.elements.create('payment', {
            layout: 'tabs', // Mostra i metodi di pagamento in tab
        });

        // Monta il Payment Element
        this.paymentElement.mount('#payment-element');

        // Aggiungi un listener per validare il form
        this.paymentElement.on('change', (event) => {
        this.isFormValid = !event.error && event.complete; // Abilita il bottone solo se completo e senza errori
        this.errorMessage = event.error ? event.error.message : null; // Mostra eventuali errori

        //gestione selezione metodo di pagamento
        if (event.value.type === 'card') {
            //CARTE DI CREDITO
            console.log('Carta di credito');
            this.selectedPaymentMethod = 'card';

        } else if (event.value.type === 'sepa_debit') {
            // SEPA
            console.log('SEPA');
            this.selectedPaymentMethod = 'sepa_debit';

        } else if (event.value.type === 'paypal') {
            // PAYPAL
            console.log('PAYPAL');
            this.selectedPaymentMethod = 'paypal';

        } else {
            //altro per il futuro ...
            console.log('Altro');
        }

        });

        //visualizza bottone "paga"
        console.log("visualizza bottone Aggiorna metodo di pagamento ---")
        this.isButtonVisible = true;

    } else {
        //Oneshot => non ha rinnovo => quindi niente possibilità di cambiare metodo di pagamento dovuto al rinnovo ;-)
        console.log("Siamo in ONESHOT ---------------") 
        console.log("quindi niente possibilità di cambiare metodo di pagamento dovuto al rinnovo ;-)")
        
        //redirect sulla scrivania
        this.$router.push({ name: 'area-clienti-dashboard' })
    }
    
  },
  methods: {
    prezzoFormattatoStripeQUI(prezzo, iva) {
      if (typeof prezzo === 'number') {
          if (iva == 1) {
            prezzo *= 1.22;
          }

          let prezzoStringa = (prezzo / 100).toFixed(2); // Dividiamo per 100 per ottenere il valore con due decimali
          let [prezzo_intero, prezzo_decimali] = prezzoStringa.split('.'); // Separiamo la parte intera e decimale
          let prezzo_elab = prezzo_intero + "," + prezzo_decimali; // Usando la virgola per separare i decimali
          // Aggiungiamo il separatore delle migliaia con il punto
          return prezzo_elab.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
      } else {
          return "---";
      }
    },

    async createPaymentMethod() {
      try {
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card', // Puoi specificare altri tipi, come 'ideal' o 'bancontact'
          card: this.elements.getElement('card'), // Ottieni l'elemento card dai tuoi elementi
        });

        if (error) {
          console.error('Errore durante la creazione del metodo di pagamento:', error);
          //return null; // O gestisci l'errore come preferisci
        }

        // Associa il metodo di pagamento al cliente
        const { error: attachError } = await this.stripe.attachPaymentMethod(paymentMethod.id, {
          customer: this.field_customer, // l'ID cliente associato -> "cus_XXXXXX"
        });

        if (attachError) {
          console.error('Errore durante l\'associazione del metodo di pagamento:', attachError);
          //return null; // O gestisci l'errore come preferisci
        }

        console.log('ID del metodo di pagamento creato e associato:' + paymentMethod.id); // Restituisci l'ID del metodo di pagamento
      } catch (error) {
        console.error('Errore durante la creazione o l\'associazione del metodo di pagamento:', error);
        //return null; // O gestisci l'errore come preferisci
      }
    },
    
    async handleSubmit() {
        this.isLoading = true;
        this.errorMessage = null;

        if (!this.stripe || !this.elements || !this.paymentElement || !this.clientSecretOk) {
            this.errorMessage = 'Stripe Elements non è stato inizializzato correttamente.';
            console.error(this.errorMessage);
            console.error('Stripe:', this.stripe);
            console.error('Elements:', this.elements);
            console.error('Payment Element:', this.paymentElement);
            console.error('Client Secret:', this.clientSecretOk);
            this.isLoading = false;
            return;
        }

        try {
            const { setupIntent, error } = await this.stripe.confirmSetup({
                elements: this.elements,
                redirect: 'if_required',
            });

            if (error) {
                this.errorMessage = error.message;
                console.error('Errore nella conferma del SetupIntent:', error);
                this.isLoading = false;
                return;
            }

            // Invia al backend il payment_method_id per collegarlo al customer e retry del pagamento
            const response = await this.$http.post(`/api/customer/stripe/attach-and-confirm-payment-abbonamento-fallito/${this.field_payment_intent}`, {
                payment_method_id: setupIntent.payment_method,
            });

            console.log('Metodo di pagamento aggiornato e pagamento avviato:', response.data);
            this.isSuccess = true;

        } catch (err) {
            console.error('Errore durante aggiornamento metodo di pagamento e pagamento:', err.response?.data?.error || err.message);
            this.errorMessage = err.response?.data?.error || 'Errore durante l\'aggiornamento del metodo di pagamento.';
        } finally {
            this.isLoading = false;
        }
    },


    
  },
};
</script>

<style>
.error {
  color: red;
  padding-top: 20px;
}
</style>
